module.exports = __webpack_public_path__ + "img/fushimi-HP-back001sp.73687f93.jpg";